import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "panel panel-section request-staff-hour-panel p-bottom-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading request-staff-hour-panel-header has-background-light has-text-weight-semibold is-size-4" }, " Staff time ", -1)
const _hoisted_3 = {
  key: 0,
  class: "request-staff-hour-panel-content p-bottom-8"
}
const _hoisted_4 = { class: "p-bottom-8" }
const _hoisted_5 = ["name", "hours"]
const _hoisted_6 = { class: "has-text-weight-semibold p-left-12 p-top-4" }
const _hoisted_7 = { class: "p-bottom-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-weight-semibold p-left-12" }, "Total staff hours", -1)
const _hoisted_9 = { class: "p-left-24 p-top-8" }
const _hoisted_10 = { class: "p-bottom-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-weight-semibold p-left-12" }, "Staff cost", -1)
const _hoisted_12 = { class: "p-left-24 p-top-8" }
const _hoisted_13 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrModal = _resolveComponent("NrModal")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (!_ctx.filteredRequestLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestStaffHours, (hours, name) => {
              return (_openBlock(), _createElementBlock("div", {
                name: name,
                hours: hours,
                key: name
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hours, (hour) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: hour.id
                  }, [
                    (hour.invoice_id != null)
                      ? (_openBlock(), _createBlock(_component_NrTooltip, {
                          key: 0,
                          label: 
                hour.paid ? 'Paid in previous invoice' : 'Waiting for payment'
              ,
                          class: "panel-item is-flex is-align-items-center is-justify-content-space-between request-staff-hour--sent"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(hour.staff_hour) + " " + _toDisplayString(hour.exclude_time_on_invoice ? '(Tracking Only)' : ''), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", {
                'panel-item--editable': _ctx.$can('publish', 'Request')
              }])
                        }, [
                          _createTextVNode(_toDisplayString(hour.staff_hour) + " " + _toDisplayString(hour.exclude_time_on_invoice ? '(Tracking Only)' : '') + " ", 1),
                          _createElementVNode("div", null, [
                            (_ctx.$can('publish', 'Request'))
                              ? (_openBlock(), _createBlock(_component_NrTooltip, {
                                  key: 0,
                                  label: "Edit staff hours"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_NrIconButton, {
                                      variant: "minimal-neutral",
                                      icon: { name: 'pencil-alt', type: 'regular' },
                                      "aria-label": "Edit staff hours",
                                      onClick: ($event: any) => ($options.processEditClick(hour))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (_ctx.$can('publish', 'Request'))
                              ? (_openBlock(), _createBlock(_component_NrTooltip, {
                                  key: 1,
                                  label: "Delete staff hours"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_NrIconButton, {
                                      variant: "minimal-neutral",
                                      "aria-label": "Delete staff hours",
                                      icon: { name: 'trash-alt', type: 'regular' },
                                      onClick: ($event: any) => (
                      $options.processDeleteClick(
                        hour,
                        'deleteStaffHourConfirmationDialog'
                      )
                    )
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                  ]))
                }), 128))
              ], 8, _hoisted_5))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString($props.totalStaffHours), 1)
          ], 512), [
            [_vShow, $props.totalStaffHours]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString($options.formatCost($props.staffCost)), 1)
          ], 512), [
            [_vShow, $props.staffCost]
          ]),
          _createVNode(_component_NrModal, {
            class: "delete-staff-time",
            title: "Delete Staff Time",
            "confirm-button-styles": "is-danger",
            primaryButtonText: "Delete",
            "cancel-button-styles": "is-primary is-outlined",
            secondaryButtonText: "Cancel",
            hasSecondaryButton: true,
            show: _ctx.activeModal === 'deleteStaffHourConfirmationDialog',
            "disable-submit": false,
            onOnPrimaryClick: _cache[0] || (_cache[0] = ($event: any) => ($options.processDeleteStaffSubmit())),
            onOnSecondaryClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveModal(null)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_13, _toDisplayString($options.deleteStaffHourConfirmationText), 1)
            ]),
            _: 1
          }, 8, ["show"])
        ]))
      : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
          key: 1,
          count: 3
        }))
  ]))
}